import { pxToRem } from '@/utils';
import { css } from '@emotion/css';

const styles = {
  container: css`
    flex-basis: 33.33%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${pxToRem(32)};
    cursor: pointer;
    box-sizing: border-box;
    padding: ${pxToRem(8)}; ;
  `,
  card: css`
    width: ${pxToRem(80)};
    min-height: ${pxToRem(80)};
  `,
  icon: css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  `,
  iconShadow: css`
    filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.15)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
  `,
  title: css`
    text-align: center !important;
    width: 100%;
    max-height: ${pxToRem(73)};
  `,
};

export default styles;
